/* eslint-disable max-len */
import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const StarOutlineIcon = ({ ...props }: IconProps) => {
  return (
    <BaseIcon {...props}>
      <path d="M16 7.54 18.38 11a3 3 0 0 0 1.63 1.18l4.04 1.2-2.57 3.33a3 3 0 0 0-.62 1.92l.11 4.2-3.97-1.4a3 3 0 0 0-2 0l-3.97 1.4.11-4.2a3 3 0 0 0-.62-1.92L7.95 13.4l4.04-1.2a3 3 0 0 0 1.63-1.18L16 7.54Zm.82-2.34a1 1 0 0 0-1.65 0l-3.2 4.68a1 1 0 0 1-.54.4l-5.44 1.6a1 1 0 0 0-.51 1.57l3.46 4.5a1 1 0 0 1 .2.63L9 24.25a1 1 0 0 0 1.33.97l5.35-1.9a1 1 0 0 1 .67 0l5.34 1.9a1 1 0 0 0 1.33-.97l-.15-5.67a1 1 0 0 1 .2-.64l3.46-4.5a1 1 0 0 0-.5-1.56l-5.45-1.6a1 1 0 0 1-.54-.4l-3.2-4.68Z" />
    </BaseIcon>
  );
};
